import {AfterViewInit, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {EnterpriseService} from 'src/app/core/services/enterprise.service';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {NotificationService} from 'src/app/core/services/notification.service';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSelect} from '@angular/material';
import {FormControl, NgForm} from '@angular/forms';
import { BehaviorSubject, Observable, Observer, ReplaySubject, Subject, Subscription } from 'rxjs';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {first, map, takeUntil} from 'rxjs/operators';
import {DataSource} from '@angular/cdk/table';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {CommonService} from 'src/app/core/services/common.service';
import {OtpVerifyComponent} from '../../enterprise/otp-register/otp-verify/otp-verify.component';
// @ts-ignore
import {NzUploadFile} from 'ng-zorro-antd/upload';
import {DomSanitizer} from '@angular/platform-browser';
import {UsbTokenService} from '../../../../../../core/services/usb-token.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {CertificateType} from 'src/app/core/constants/common';
import {DefaultSignImageType} from '../default-sign-image-config/default-sign-image-config.component';
import {EnumSignMethod} from "../../../../../../core/constants/contract";
import {DigitalCertificateCloudCaDataSource} from "../../../../../../core/class/digital-certificate-cloud-ca-data-source";
import {DowloadAppMobileComponent} from "../../../../../../shared/components/dowload-app-mobile/dowload-app-mobile.component";
import { DowloadAppVNeIDMobileComponent } from 'src/app/shared/components/dowload-app-vneid-mobile/dowload-app-vneid-mobile.component';
import { DocumentService } from 'src/app/core/services/document.service';
import { Common } from '../../../../../../core/constants/common';
import { Router } from '@angular/router';

declare function initPluginCertificate(comp: any): any;

/**
 * Define type upload when type certificate is USB-Token
 * 0. UPLOAD_FROM_SELECT_FILE: is select file .cer or .cert
 */
const UPLOAD_FROM_SELECT_FILE = 0;

/**
 * Define error status pending/active of certificate (HSM and signuater server)
 * 0. HSM_STATUS_PENDING: is status pending of certificate HSM
 * 1. HSM_STATUS_ACTIVE: is status active of certificate HSM
 * 2. SERVER_STATUS_PENDING: is status pending of certificate Signuater Server
 * 3. SERVER_STATUS_ACTIVE: is status active of certificate Signuater Server
 * 4. SERVER_STATUS_PENDING_HSM: is status pending of certificate Signuater Server when Hsm Pending
 */
const HSM_STATUS_PENDING = 0;
const HSM_STATUS_ACTIVE = 1;
const SERVER_STATUS_PENDING = 2;
const SERVER_STATUS_ACTIVE = 3;
const SERVER_STATUS_PENDING_HSM = 4;
const HSM_STATUS_PENDING_SERVER = 5;

/**
 * Define certificate type
 * 0. SIGNATURE_SERVER:
 * 1. USBTOKEN:
 * 2. SIMCA:
 * 4. HSM:
 */
const SIGNATURE_SERVER = 0;
const USBTOKEN = 1;
const SIMCA = 2;
const OTP = 3;
const HSM = 4;

@Component({
  selector: 'app-add-digital-certificate',
  templateUrl: './add-digital-certificate.component.html',
  styleUrls: ['./add-digital-certificate.component.scss'],
})
export class AddDigitalCertificateComponent implements OnInit, OnDestroy, AfterViewInit {
  certData: BehaviorSubject<any>;
  /**
   * Check aggree inform
   */
  checkAgree: boolean;

  /**
   *
   */
  @BlockUI() blockUI: NgBlockUI;

  // displayedColumns: string[] = [
  //   'check',
  //   'stt',
  //   'certificateName',
  //   'serialNumber',
  //   'taxCode',
  //   'activeDate',
  //   'expireDate',
  //   'isUsed'
  // ];
  displayedColumns: string[] = [];

  columnDefinitions = [
    {def: "check", showMobile: true},
    {def: "stt", showMobile: true},
    {def: "certificateName", showMobile: true},
    {def: "serialNumber", showMobile: false},
    {def: "taxCode", showMobile: false},
    {def: "activeDate", showMobile: false},
    {def: "expireDate", showMobile: true},
    {def: "isUsed", showMobile: true},
  ];

  displayedColumnsCloudCa: string[] = [];

  columnDefinitionsCloudCa = [
    {def: "check", showMobile: true},
    {def: "stt", showMobile: true},
    {def: "certificateName", showMobile: true},
    {def: "cloudCaUserId", showMobile: false},
    {def: "serialNumber", showMobile: false},
    {def: "taxCode", showMobile: false},
    {def: "activeDate", showMobile: false},
    {def: "expireDate", showMobile: true},
    {def: "isUsed", showMobile: true},
  ];
  displayedColumnsEasyCa: string[] = [];
  columnDefinitionsEasyCa = [
    {def: "check", showMobile: true},
    {def: "stt", showMobile: true},
    {def: "issuedTo", showMobile: true},
    {def: "serialNumber", showMobile: false},
    {def: "taxCode", showMobile: false},
    {def: "activeDate", showMobile: false},
    {def: "expireDate", showMobile: true},
    {def: "isUsed", showMobile: true},
  ];

  displayedColumnsVNeID: string[] = [];
  columnDefinitionsVNeID = [
    {def: "check", showMobile: true},
    {def: "stt", showMobile: true},
    {def: "issuedBy", showMobile: false},
    {def: "certificateName", showMobile: true},
    {def: "serialNumber", showMobile: false},
    {def: "taxCode", showMobile: false},
    {def: "activeDate", showMobile: false},
    {def: "expireDate", showMobile: true},
    {def: "isUsed", showMobile: true},
  ];
  dataSource: DigitalCertificateSimCADataSource;
  certificateType = EnumSignMethod;
  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  cloudCaDataSource: DigitalCertificateCloudCaDataSource;
  easyCaDataSource: DigitalCertificateEasyCaDataSource
  VNeIDDataSource: DigitalCertificateVNeIDDataSource;
  lstCloudCaProvider: CloudCaProvider[];
  isShowNote= false
  /**
   * Model digital certificate
   */
  digitalCertificate = {
    id: 0,
    enterpriseId: localStorage.getItem('enterpriseId'),
    typeCertificate: 2,     // set default value = SimCA
    phoneNumber: '',
    filePath: '',
    fileName: '',
    lstUserIdManagement: [],
    digitalCertificateDetail: [{
      serialNumber: '',
      issuedTo: '',
      distinguishedName: '',
      issuedBy: '',
      certRawdata: '',
      activeDate: null,
      expireDate: null,
      taxCode: '',
      imagePath: null,
      signAlgo: '',
      taxcodeCertno: '',
      cloudCaUserId: '',
      credentialId: '',
      providerName: ''
    }],
    providerName: '',
    providerId: null,
    cloudCaUsername: '',
    credentialId: '',
    isExtend: false,
    pin: '',
    serial: '',
    isSavePin: false,
    isSync: false,
    VNeIDDataUser: '',
  };

  checkFocus = false;
  /**
   * Detect form changing
   */
  isFormChanging = false;

  /**
   * show note when have new cert Mysign
   */
  showExistNoteCert = true;
  /**
   * Obj branch
   */
  branch: comboBox[] = [];

  branchFilterCtrl: FormControl = new FormControl();

  //Check feature contract moha
  checkMoha = false;

  public filteredBranch: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();
  /**
   * Check size of input upload
   */
  maxSizeInput = false;

  /**
   * File upload for case usb token
   */
  fileUpload: any = '';
  fileImageUpload: any = '';

  // cấu hình ảnh ký mặc định khi tạo mới (PYC-84222 task 3)
  // tab block đang mở mặc định là Ảnh hệ thống; khởi tạo luôn type để user đứng nguyên tab 1
  // (chỉ bấm Sửa rồi Xong, không chuyển tab) vẫn gửi được defaultSignConfig xuống BE khi lưu
  pendingDefaultSignImageType: DefaultSignImageType = DefaultSignImageType.SYSTEM;
  pendingSignConfigJson: string = null;
  pendingUploadImageBase64: string = null;
  pendingDrawImageBase64: string = null;
  // ảnh ký nhúng trong ảnh hệ thống (raw base64); null = không có ảnh mới
  pendingSignatureImageBase64: string = null;

  onDefaultSignImageTypeChange(type: DefaultSignImageType) {
    this.pendingDefaultSignImageType = type;
    this.isFormChanging = true;
  }

  onPendingSignConfigChange(json: string) {
    this.pendingSignConfigJson = json;
    this.isFormChanging = true;
  }

  onPendingSignatureImageChange(base64: string) {
    this.pendingSignatureImageBase64 = base64;
    this.isFormChanging = true;
  }

  onPendingUploadImageChange(base64: string) {
    this.pendingUploadImageBase64 = base64;
    this.isFormChanging = true;
  }

  onPendingDrawImageChange(base64: string) {
    this.pendingDrawImageBase64 = base64;
    this.isFormChanging = true;
  }

  /** tab Ảnh tải lên/Vẽ chỉ hợp lệ khi có ảnh MỚI (màn thêm mới chưa có ảnh nào lưu sẵn) -> khóa nút Lưu (PYC-84222) */
  get isSignImageInvalid(): boolean {
    if (this.pendingDefaultSignImageType === DefaultSignImageType.UPLOAD) {
      return !this.pendingUploadImageBase64;
    }
    if (this.pendingDefaultSignImageType === DefaultSignImageType.DRAW) {
      return !this.pendingDrawImageBase64;
    }
    return false;
  }

  /**
   * Name of enterprise
   */
  enterpriseName = '';

  /**
   * Subscription to form changing
   */
  formChangesSubscription: Subscription;

  /**
   * Check form change before navigate
   */
  show = true;

  /**
   * Value of select upload file with usb-token
   */
  valueSelectUpload = 1;

  /**
   * Check error when initPlugin
   */
  errorInitPlugin = true;

  /**
   * Code error
   */
  codeError: number;

  /**
   * Error check status for certificate with HSM, signuater server
   */
  errorStatus = null;

  // check to alow create muti user or not
  isMultiCreateUser = false;

  /**
   * Value selected CertificateType
   */
  valueSelectCertificateType = null;
  checkEscKey = false;

  /**
   * user Type
   */
  userType: any;

  /**
   * Check certificate for sim CA
   */
  checkAll: boolean;

  /**
   * Check type file is .cer or .cert
   */
  errorFormatTypeFile = false;

  /**
   * Check enable button save for case create sim CA
   */
  enableButtonSave: boolean;

  /**
   * Check process success
   */
  success = false;

  isCreateMysign = false;
  isDigital = false;
  isEmploymentContract = false;
  isSignDigitalCert = false;
  /**
   * Refresh input file
   */
  @ViewChild('inputUpload', {read: '', static: false}) inputUploadFile: ElementRef;

  /**
   * Refer to form in view
   */
  @ViewChild('f', {static: false}) ngForm: NgForm;
  @ViewChild('typeCertificateSelect', {static: false}) typeCertificateSelect: MatSelect;
  @ViewChild('uploadSelect', {static: false}) uploadSelect: MatSelect;
  public previewVisible: boolean;
  public loading: boolean;
  public avatarUrl: string;
  private imagePath: any;
  wrongFileFormat = false;
  fileTooLarge = false;
  sessionId: string;
  isVNeIDPermission: boolean;
  phonePattern2 = Common.PHONE_PATTERN2;
  checkUserType = false;

  userNameArr = [];
  inputUserValue: string;
  filteredUserOptions = [];
  nzCheckLoadingUser = false;
  isHsmPermission: boolean = false
  isEasyCAPermission: boolean = false
  showPinCode: boolean = false
  entType = localStorage.getItem('entType')
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (!this.checkEscKey) {
      this.onNoClick();
    }
  }

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  constructor(
    private el: ElementRef,
    public commonService: CommonService,
    private enterpriseService: EnterpriseService,
    private digitalCertificateService: DigitalCertificateService,
    private toastr: ToastrService,
    public notificationService: NotificationService,
    private message: Message,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AddDigitalCertificateComponent>,
    private sanitizer: DomSanitizer,
    private usbTokenService: UsbTokenService,
    public deviceService: DeviceDetectorService,
    public documentService: DocumentService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onNoClick();
    });
    if (this.data && this.data.isCreateMysign) {
      this.isCreateMysign = true;
    }
    if (this.data && this.data.isEmploymentContract) {
      this.isEmploymentContract = true;
    }
    if (this.data && this.data.isDigital) {
      this.isDigital = true;
    }
    if (this.data && this.data.isSignDigitalCert) {
      this.isSignDigitalCert = true;
    }
    this.previewVisible = false;
    this.userType = localStorage.getItem('userType');
    this.loading = false;
    this.certData = new BehaviorSubject<any>(null);

    this.getDisplayedColumns();
  }

  /**
   * Init component
   */
  ngOnInit() {
    // 1. Lấy toàn bộ chuỗi URL hiện tại (ví dụ: /home-enterprise/...?goFrom=digitalMy)
    const fullUrl = this.router.url;

    // 2. Sử dụng URLSearchParams để trích xuất tham số
    // Chúng ta dùng split('?')[1] để chỉ lấy phần sau dấu hỏi chấm
    const queryParams = new URLSearchParams(fullUrl.split('?')[1]);
    const goFrom = queryParams.get('goFrom');

    if (goFrom && goFrom === 'digitalMyEmployment') {
      this.checkMoha = true;
      this.digitalCertificate.typeCertificate = 1;
    }
    this.branchFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.commonService.filterCertificateType(this.branch, this.branchFilterCtrl, this.filteredBranch);
    });

    this.getEnterprise();

    this.notificationService.subscribeErrorService();

    this.certData.asObservable().subscribe((data) => {
      if (data) {
        console.log('lay duoc thong tin chung thu so', data);
      }
    });

    this.commonService.getAllCloudCaProvider().subscribe(rs => {
      if (rs && rs.data) {
        this.lstCloudCaProvider = rs.data.map(item => ({
          name: item.name,
          id: item.id
        }));
        this.digitalCertificate.providerName = this.lstCloudCaProvider[0].name;
        this.digitalCertificate.providerId = this.lstCloudCaProvider[0].id;
      }
    })

    this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
      if(res && res.success){
        this.isHsmPermission = res.data.enableHsm
        this.isEasyCAPermission = this.entType == '2' ? res.data.isEnableEasyCa : false
        // this.isEasyCAPermission = res.data.enableEasyCa
      }
    })


    this.documentService.getApparamInfo({code: 'enable_sign_vneid'}).subscribe(res => {
      if(res.data){
        this.isVNeIDPermission = JSON.parse(res.data.value) && res.data.status;
      }
    });
    const url = this.router.url;

    const segments = url.split('/');
    const value = segments[segments.length - 1];
    if(this.isEmploymentContract){
    if(Number(this.userType) === 5 || Number(this.userType) === 3){
       if(value != "digital-certificate"){
      this.digitalCertificate.typeCertificate = 10;
      this.checkUserType = true;
      }
    }
  }
  }

  /**
   * Implement AfterViewInit method, check form dirty
   */
  ngAfterViewInit() {
    setTimeout(_ => this.typeCertificateSelect.focused = true);
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.formChangesSubscription.unsubscribe();
  }

  getDisplayedColumns() {
    if (this.deviceService.isMobile()) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }

    if (this.deviceService.isMobile()) {
      this.displayedColumnsCloudCa = this.columnDefinitionsCloudCa
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumnsCloudCa = this.columnDefinitionsCloudCa.map(cd => cd.def);
    }

    if (this.deviceService.isMobile()) {
      this.displayedColumnsEasyCa = this.columnDefinitionsEasyCa
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumnsEasyCa = this.columnDefinitionsEasyCa.map(cd => cd.def);
    }

    if (this.deviceService.isMobile()) {
      this.displayedColumnsVNeID = this.columnDefinitionsVNeID
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumnsVNeID = this.columnDefinitionsVNeID.map(cd => cd.def);
    }
  }

  dummyRequest = ({file, onSuccess, onError}) => {
    this.fileImageUpload = file;
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  handleChange(info: { file: NzUploadFile }): void {
    this.isFormChanging = true;
    this.wrongFileFormat = false;
    this.fileTooLarge = false;
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          // this.fileUpload = info.file;
          this.avatarUrl = img;
        });
        break;
      case 'error':
        this.toastr.error('Network error');
        this.loading = false;
        break;
    }
  }

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.wrongFileFormat = true;
        this.fileTooLarge = false;
        // this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg'));
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.wrongFileFormat = false;
        this.fileTooLarge = true;
        // this.toastr.error(this.message.getMessage('messages.image_must_than_5m'));
        observer.complete();
        return;
      }
      observer.next(isJpgOrPng && isLt2M);
      observer.complete();
    });
  }

  /**
   * Get inform of enterprise with enterpriseId current
   */
  getEnterprise() {
    this.enterpriseService.getEnterpriseByID(localStorage.getItem('enterpriseId')).subscribe(rs => {
      this.enterpriseName = rs.data.name;

      // Get list for combobox branch/enterprise when is customer
      if (Number(this.userType) === 5) {
        this.branch.push(rs.data);
        this.filteredBranch.next(this.branch.slice());
      }
    });
  }

  /**
   * Get file input
   * @param e event input
   */
  getFile(evt) {
    if (typeof (FileReader) !== 'undefined') {
      const file = evt.target.files[0];
      // Check format of file
      if (!this.checkFormatTypeFile(file)) {
        // Check size of file
        if (!this.checkSize(file.size)) {
          this.digitalCertificate.fileName = file.name;

          const reader = new FileReader();

          reader.onload = (e: any) => {
            // Base64 string of file
            const binaryData = e.target.result;
            this.digitalCertificate.digitalCertificateDetail[0].certRawdata = window.btoa(binaryData);
            this.getInformCertificateFromFile(window.btoa(binaryData), file);
          };
          // Read in the image file as a data URL.
          reader.readAsBinaryString(file);
        }
      } else {
        if (!this.toastr.findDuplicate(this.message.getMessage('validation.file_format_error'), true, true)) {
          this.toastr.error(this.message.getMessage('validation.file_format_error'));
        }
      }
      this.reset();
    }
  }

  /**
   * Check type file when upload ( Accept file img and pdf )
   */
  checkFormatTypeFile(file): boolean {
    if (file.type !== 'application/x-x509-ca-cert') {
      this.errorFormatTypeFile = true;
      return true;
    } else {
      return false;
    }
  }

  /**
   * Get inform certificate from file
   * @param baseString base64 of file
   */
  getInformCertificateFromFile(baseString: string, file) {
    this.digitalCertificateService.getInformCertificateFromFile({
      certRawdata: baseString
    }).subscribe(rs => {
      this.errorStatus = null;
      this.fileUpload = file;
      this.setActiveDate(rs.data.activeDate);
      this.setExpireDate(rs.data.expireDate);
      this.setIssuedTo(rs.data.certificateName);
      this.setSerialNumber(rs.data.serialNumber);
      this.setDistinguishedName(rs.data.distinguishedName);
      this.setIssuedBy(rs.data.issuedBy);
      this.setCertRawdata(baseString);
      this.setTaxCode(rs.data.taxCode);
    });
  }

  /**
   * Check size of file upload
   */
  private checkSize(fileSize): boolean {
    if (fileSize > 5242880) {
      this.maxSizeInput = true;
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_file_5mb'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_file_5mb'));
      }
      return true;
    } else {
      this.maxSizeInput = false;
      return false;
    }
  }

  /**
   * Refresh input
   */
  private reset() {
    this.inputUploadFile.nativeElement.value = '';
  }

  /**
   * Add digital certificate
   */
  add() {
    if (this.digitalCertificate.isExtend) {
      this.onExtend(this.digitalCertificate);
      return;
    }
    if (this.fileImageUpload) {
      this.processAddWithImage();
    } else {
      this.processAddNoImage();
    }
  }

  processAddNoImage() {
    switch (this.digitalCertificate.typeCertificate) {
      case USBTOKEN:
        this.processAddCertificateWithUsbToken();
        break;
      case HSM:
        this.processAddCertificateWithHsm();
        break;
      case OTP:
        this.processAddCertificateWithOTP();
        break;
      case SIMCA:
        const data = this.dataSource.data.value.filter(item => item.checked);
        this.setSerialNumber(data[0].serialNumber);
        this.setCertRawdata(data[0].certificates[0])
        this.processAdd();
        break;
      case this.certificateType.CLOUD_CA:
        this.preProcessCloudCa();
        this.processAdd();
        break;
      case SIGNATURE_SERVER: {
        this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
          if (res && res.success) {
            if (res.data.enableHsm) {
              this.processAdd();
            } else {
              this.toastr.error(this.message.getMessage('messages.not_hsm_permission'))
            }
          }
        })
        break;
      }
      case this.certificateType.EASY_CA: {
        const data = this.easyCaDataSource.data.value.filter(item => item.checked)[0];
        this.setIssuedTo(data.issuedTo)
        this.setSerialNumber(data.serialNumber)
        this.setDistinguishedName(data.distinguishedName)
        this.setIssuedBy(data.issuedBy)
        this.setCertRawdata(data.certRawdata)
        this.setActiveDate(data.activeDate)
        this.setExpireDate(data.expireDate)
        this.processAdd();
        break;
      }
      case this.certificateType.VNEID: {
        const data = this.VNeIDDataSource.data.value.filter(item => item.checked)[0];
        this.setIssuedTo(data.issuedTo)
        this.setSerialNumber(data.serialNumber)
        this.setDistinguishedName(data.distinguishedName)
        this.setIssuedBy(data.issuedBy)
        this.setCertRawdata(data.certRawdata)
        this.setActiveDate(data.activeDate)
        this.setExpireDate(data.expireDate)
        this.processAdd();
        break;
      }
    }
  }

  preProcessCloudCa() {
    if (!this.cloudCaDataSource) {
      this.toastr.error(this.message.getMessage('messages.not_certificate'));
      return;
    }
    const dataClouds = this.cloudCaDataSource.data.value.filter(item =>  item && item.checked);

    if (dataClouds.length <= 0) {
      this.toastr.error(this.message.getMessage('messages.not_certificate'));
      return;
    }
    const dataCloud = dataClouds[0];
    this.setActiveDate(dataCloud.activeDate);
    this.setExpireDate(dataCloud.expireDate);
    this.setIssuedTo(dataCloud.certificateName);
    this.setSerialNumber(dataCloud.serialNumber);
    this.setSignAlgo(dataCloud.signAlgo);
    this.setDistinguishedName(dataCloud.distinguishedName);
    this.setIssuedBy(dataCloud.issuedBy);
    this.setTaxCode(dataCloud.taxCode);
    this.setTaxCodeCertNo(dataCloud.taxCode);
    this.setCredentialId(dataCloud.credentialId);
    this.setCertRawdata(dataCloud.certificates[0])
    this.digitalCertificate.cloudCaUsername = dataCloud.cloudCaUserId;

  }

  processAddWithImage() {
    this.digitalCertificateService.uploadFileImageBase64(this.fileImageUpload).then(rs => {
      this.digitalCertificate.digitalCertificateDetail[0].imagePath = rs.data;
      this.digitalCertificate.filePath = rs.data;
      this.imagePath = rs.data;
      this.processAddNoImage();
    });
  }

  getCertificateById(id: string, idDetail: string) {
    this.digitalCertificateService.viewDigitalCertificateDetail(id, idDetail).subscribe(rs => {
      if (!rs.data) {
        return;
      }
      const {imagePath} = rs.data;
      this.userNameArr = rs.data.lstIdNameDTO;
      if (imagePath) {
        const imageDataBlob = this.commonService.b64toBlob(imagePath);
        const blobUrl = URL.createObjectURL(imageDataBlob);
        this.avatarUrl = blobUrl;

        this.fileImageUpload = new File([imageDataBlob], 'certificate.png', { type: 'image/png' });
        // this.previewVisible = true;
      } else {
        this.fileImageUpload = null;
      }
    });
  }
  /**
   * Process when add certificate with HSM
   */
  processAddCertificateWithHsm() {
    this.digitalCertificateService.addCertificateHsm({
      enterpriseId: this.digitalCertificate.enterpriseId
    }).subscribe(rs => {
      if (rs.data) {
        this.toastr.success(this.message.getMessage('messages.add_certificate_success'));
        this.success = true;
        if (this.isMultiCreateUser) {
          this.ngForm.resetForm();
          setTimeout(_ => this.typeCertificateSelect.focused = true);
        } else {
          this.dialogRef.close();
        }
      }
    });
  }

  /**
   * Process when add certificate with HSM
   */
  processAddCertificateWithOTP() {
    this.digitalCertificateService.generateTransaction(
      this.digitalCertificateService.formatPhoneNumber(this.digitalCertificate.phoneNumber)
    ).subscribe(rs => {
      this.openDialogConfirmOTP(rs.data);
    });
  }

  processAddCertificateWithOTPImage() {
    this.digitalCertificateService.generateTransaction(
      this.digitalCertificateService.formatPhoneNumber(this.digitalCertificate.phoneNumber)
    ).subscribe(rs => {
      this.openDialogConfirmOTPImage(rs.data);
    });
  }

  /**
   * Open dialog confirm Otp
   * @param transactionId transactionId after generate numberphone
   */
  openDialogConfirmOTP(transactionId) {
    let lstUserIdManagement;
    if (this.userNameArr && this.userNameArr.length > 0) {
      lstUserIdManagement = this.userNameArr.map(cert => cert.id);
    }
    const dialogRe = this.dialog.open(OtpVerifyComponent, {
      width: '40%',
      data: {
        transaction: transactionId,
        phone: this.digitalCertificateService.formatPhoneNumber(this.digitalCertificate.phoneNumber),
        imagePath: this.imagePath,
        digitalCertificateDetail: this.digitalCertificate.digitalCertificateDetail,
        lstUserIdManagement
      }
    });

    dialogRe.afterClosed().subscribe(rs => {
      if (dialogRe.componentInstance.success) {
        this.success = true;
        this.dialogRef.close();
      }
    });
  }

  openDialogConfirmOTPImage(transactionId) {
    const dialogRe = this.dialog.open(OtpVerifyComponent, {
      width: '40%',
      data: {
        transaction: transactionId,
        phone: this.digitalCertificateService.formatPhoneNumber(this.digitalCertificate.phoneNumber),
        image: this.fileImageUpload,
      }
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (dialogRe.componentInstance.success) {
        this.success = true;
        this.dialogRef.close();
      }
    });
  }

  /**
   * Process when add certificate with usb token
   */
  processAddCertificateWithUsbToken() {
    if (this.valueSelectUpload === UPLOAD_FROM_SELECT_FILE) {
      this.processUpload();
    } else {
      if (!this.errorInitPlugin) {
        if (this.checkDataForDigitalCertificateDetail()) {
          if (!this.toastr.findDuplicate(this.message.getMessage('messages.not_certificate'), true, true)) {
            this.toastr.error(this.message.getMessage('messages.not_certificate'));
          }
        } else {
          this.processAdd();
        }
      } else {
        this.errorStatus = 'messages.choose_certificate';
      }
    }
  }

  /**
   * Process upload file when select type upload is Select file .cer or .cert
   */
  processUpload() {
    if (this.fileUpload) {
      this.digitalCertificateService.uploadFile(this.fileUpload).subscribe(rs => {
        this.digitalCertificate.filePath = rs.data;
        this.processAdd();
      });
    } else {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.no_file_attach'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.no_file_attach'));
      }
    }
  }

  /**
   * Process add digitalCertificate
   */
  isProcess = false;

  processAdd() {
    if (this.isProcess) {
      return;
    }

    this.isProcess = true;
    if (this.userNameArr && this.userNameArr.length > 0) {
      this.digitalCertificate.lstUserIdManagement = this.userNameArr.map(cert => cert.id);
    }
    const tempDigitalCertificate = {...this.digitalCertificate};
    // cấu hình ảnh ký mặc định khi tạo mới (PYC-84222 task 3)
    // ảnh vẽ tái sử dụng imagePath của detail — BE phân biệt loại qua defaultSignImageType
    if (tempDigitalCertificate.digitalCertificateDetail
      && tempDigitalCertificate.digitalCertificateDetail.length > 0) {
      // object spread với field moi — ep kieu any de TS khong bao thieu property trong literal
      tempDigitalCertificate.digitalCertificateDetail[0] = {
        ...tempDigitalCertificate.digitalCertificateDetail[0],
        defaultSignImageType: this.pendingDefaultSignImageType,
        defaultSignConfig: this.pendingDefaultSignImageType === DefaultSignImageType.SYSTEM
          ? this.pendingSignConfigJson : null,
        drawSignImageBase64: this.pendingDefaultSignImageType === DefaultSignImageType.DRAW
          ? this.pendingDrawImageBase64 : null,
        // ảnh tải lên: BE upload storage rồi lưu path vào imagePath của detail
        uploadSignImageBase64: this.pendingDefaultSignImageType === DefaultSignImageType.UPLOAD
          ? this.pendingUploadImageBase64 : null,
        // ảnh ký nhúng trong ảnh hệ thống: BE upload rồi lưu path vào defaultSignConfig
        signatureImageBase64: this.pendingDefaultSignImageType === DefaultSignImageType.SYSTEM
          ? this.pendingSignatureImageBase64 : null
      } as any;
    }
    // debugger;
    // Format phone number if certificate type is SIMCA
    if (tempDigitalCertificate.typeCertificate === SIMCA) {
      tempDigitalCertificate.phoneNumber = this.digitalCertificateService.formatPhoneNumber(tempDigitalCertificate.phoneNumber);
      tempDigitalCertificate.lstUserIdManagement = this.userNameArr.map(res => res.id);
    }
    if (tempDigitalCertificate.typeCertificate === this.certificateType.CLOUD_CA) {
      tempDigitalCertificate.providerName = this.digitalCertificate.providerName;
      tempDigitalCertificate.cloudCaUsername = this.digitalCertificate.cloudCaUsername;
    }
    if (tempDigitalCertificate.typeCertificate === this.certificateType.VNEID) {
      tempDigitalCertificate.providerName = ""
      tempDigitalCertificate.cloudCaUsername = this.digitalCertificate.VNeIDDataUser;
    }

    this.digitalCertificateService.add(tempDigitalCertificate).subscribe(rs => {
      this.isProcess = false;
      if (rs.success) {
        this.success = true;
        this.toastr.success(this.message.getMessage('messages.add_cert_succcess'));
        if (this.isMultiCreateUser) {
          this.ngForm.resetForm();
          setTimeout(_ => this.typeCertificateSelect.focused = true);
        } else {
          this.dialogRef.close();
        }
      } else {
        this.toastr.error(rs.message);
      }
    });
  }

  /**
   * Event detect input change
   */
  changeInput() {
    this.isFormChanging = true;
  }

  /**
   * Event oncheck checkbox
   */
  onCheck() {
    this.isFormChanging = true;
  }

  /**
   * Get value of certificate type
   */
  onChangeSelectCertificateType(value: number) {
    this.fileImageUpload = null;
    this.avatarUrl = '';
    this.errorStatus = null;
    this.codeError = null;
    this.dataSource = null;
    this.cloudCaDataSource = null;
    this.easyCaDataSource = null;
    this.VNeIDDataSource = null;
    this.enableButtonSave = false;
    this.valueSelectCertificateType = value;

    if (this.digitalCertificate.enterpriseId != null) {
      if (this.valueSelectCertificateType === HSM) {
        this.checkCertificateStatusForHsm();
      }

      if (this.valueSelectCertificateType === SIGNATURE_SERVER) {
        this.checkCertificateStatusForServer();
      }
    }
  }

  /**
   * Event selected enterpirse
   */
  onChangeEnterprise() {
    if (this.digitalCertificate.enterpriseId != null) {
      if (this.valueSelectCertificateType === HSM) {
        this.checkCertificateStatusForHsm();
      }

      if (this.valueSelectCertificateType === SIGNATURE_SERVER) {
        this.checkCertificateStatusForServer();
      }
    }
  }

  /**
   * Get value of select upload
   */
  onChangeSelectCertificate(value: number) {
    if (value === 1) {
      this.clearDataDigitalCertificateDetail();

    } else {
      this.fileUpload = '';
      this.errorStatus = null;
    }
  }

  /**
   * Get Certificate
   */
  onGetCertificate() {
    this.blockUI.start('');
    this.digitalCertificate.digitalCertificateDetail[0] = {
      serialNumber: '',
      issuedTo: '',
      distinguishedName: '',
      issuedBy: '',
      certRawdata: '',
      activeDate: null,
      expireDate: null,
      taxCode: '',
      imagePath: null,
      signAlgo: '',
      taxcodeCertno: '',
      cloudCaUserId: '',
      credentialId: '',
      providerName: ''
    };
    // this.usbTokenService.workerGetCert();
    initPluginCertificate(this);
  }

  /**
   * Show error format form certificate.js
   * @param msg message
   */
  showErrMsgTransle(msg) {
    this.blockUI.stop();
    this.errorStatus = msg;
  }

  /**
   * Show error format form certificate.js
   * @param msg message
   */
  showErrMsgTransleFormat(msg, msg1, msg2) {
    this.blockUI.stop();

    this.errorStatus = this.commonService.format(this.message.getMessage(msg),
      this.message.getMessage(msg1), this.message.getMessage(msg2));
  }

  /**
   * Confirm when extend
   */
  onExtend(cert) {
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('certificate.note2'), [`${cert.certificateName} (${cert.serialNumber})`])
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        if (this.fileImageUpload) {
          this.processAddWithImage();
        } else {
          this.processAddNoImage();
        }
      }
      dialogRe.close();
    });
  }

  /**
   * Confirm when change form
   */
  onNoClick() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          if (this.isMultiCreateUser) {
            this.ngForm.resetForm();
            setTimeout(_ => this.typeCertificateSelect.focused = true);
          } else {
            this.dialogRef.close();
          }
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      if (this.isMultiCreateUser) {
        this.ngForm.resetForm();
        setTimeout(_ => this.typeCertificateSelect.focused = true);
      } else {
        this.dialogRef.close();
      }
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    if ((this.isFormChanging && this.show)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  /**
   * Set value for serialNumber
   * @param value value of serialNumber
   */
  setSerialNumber(value) {
    this.digitalCertificate.digitalCertificateDetail[0].serialNumber = value;
  }

  setSignAlgo(value) {
    this.digitalCertificate.digitalCertificateDetail[0].signAlgo = value;
  }

  /**
   * Set value for issuedTo
   * @param value value of issuedTo
   */
  setIssuedTo(value) {
    this.digitalCertificate.digitalCertificateDetail[0].issuedTo = value;
  }

  /**
   * Set value for distinguishedName
   * @param value value of distinguishedName
   */
  setDistinguishedName(value) {
    this.digitalCertificate.digitalCertificateDetail[0].distinguishedName = value;
  }

  /**
   * Set value for taxcode
   * @param value value of distinguishedName
   */
  setTaxCode(value) {
    this.digitalCertificate.digitalCertificateDetail[0].taxCode = value;
  }

  setTaxCodeCertNo(value) {
    this.digitalCertificate.digitalCertificateDetail[0].taxcodeCertno = value;
  }


  /**
   * Set value for issuedBy
   * @param value value of issuedBy
   */
  setIssuedBy(value) {
    this.digitalCertificate.digitalCertificateDetail[0].issuedBy = value;
  }

  /**
   * Set value for certRawdata
   * @param value value of certRawdata
   */
  setCertRawdata(value) {
    this.digitalCertificate.digitalCertificateDetail[0].certRawdata = value;
  }

  /**
   * Set value for activeDate
   * @param value value of activeDate
   */
  setActiveDate(value) {
    this.digitalCertificate.digitalCertificateDetail[0].activeDate = new Date(value);
  }

  /**
   * Set value for expireDate
   * @param value value of expireDate
   */
  setExpireDate(value) {
    this.digitalCertificate.digitalCertificateDetail[0].expireDate = new Date(value);
  }

  setCredentialId(value) {
    this.digitalCertificate.digitalCertificateDetail[0].credentialId = value;
    this.digitalCertificate.credentialId = value;
  }

  setProviderName(value) {
    this.digitalCertificate.digitalCertificateDetail[0].providerName = value;
  }

  setCertData(data) {
    // const {
    //   certBase64,
    //   serialNumber,
    //   issuedTo,
    //   distinguishedName,
    //   taxCode,
    //   issuedBy,
    //   activeDate,
    //   expireDate,
    //   activeContinueButton
    // } = data;
    let dataValid = true;
    for (const [key, value] of Object.entries(data)) {
      if (!value) {
        dataValid = false;
        break;
      }
    }
    if (dataValid) {
      this.certData.next(data);
    } else {
      this.toastr.error(this.message.getMessage('messages.certificate_info_not_valid'));
    }
  }

  /**
   * Check data of digitalCertificateDetail for add certificate with usbtoken
   */
  checkDataForDigitalCertificateDetail(): boolean {
    if (!this.digitalCertificate.digitalCertificateDetail[0].serialNumber
      || !this.digitalCertificate.digitalCertificateDetail[0].issuedTo
      || !this.digitalCertificate.digitalCertificateDetail[0].issuedBy
      || !this.digitalCertificate.digitalCertificateDetail[0].expireDate
      || !this.digitalCertificate.digitalCertificateDetail[0].distinguishedName
      || !this.digitalCertificate.digitalCertificateDetail[0].certRawdata
      || !this.digitalCertificate.digitalCertificateDetail[0].activeDate) {
      return true;
    }
  }

  /**
   * Clear data of DigitalCertificateDetail
   */
  clearDataDigitalCertificateDetail() {
    this.digitalCertificate.digitalCertificateDetail[0].activeDate = '';
    this.digitalCertificate.digitalCertificateDetail[0].distinguishedName = '';
    this.digitalCertificate.digitalCertificateDetail[0].expireDate = '';
    this.digitalCertificate.digitalCertificateDetail[0].issuedBy = '';
    this.digitalCertificate.digitalCertificateDetail[0].issuedTo = '';
    this.digitalCertificate.digitalCertificateDetail[0].serialNumber = '';
    this.digitalCertificate.digitalCertificateDetail[0].certRawdata = '';
    this.digitalCertificate.digitalCertificateDetail[0].credentialId = '';
  }

  /**
   * Check status of certificate for register certificate with type is HSM
   */
  checkCertificateStatusForHsm() {
    this.digitalCertificateService.checkStatusCertificateHsm({
      enterpriseId: this.digitalCertificate.enterpriseId
    }).subscribe(rs => {
      if (rs.code) {
        if (rs.code === '0x001A08') {
          this.codeError = HSM_STATUS_PENDING;
        }

        if (rs.code === '0x001A07') {
          this.codeError = HSM_STATUS_ACTIVE;
        }

        if (rs.code === '0x001817') {
          this.codeError = HSM_STATUS_PENDING_SERVER;
        }
      }

      if (rs.data) {
        this.codeError = null;
      }
    });
  }

  /**
   * Check status of certificate for register certificate with type is signuater server
   */
  checkCertificateStatusForServer() {
    this.digitalCertificateService.checkStatusCertificateSignuaterServer(this.digitalCertificate.enterpriseId).subscribe(rs => {
      if (rs.code) {

        if (rs.code === '0x001805') {
          this.codeError = SERVER_STATUS_PENDING;
        }

        if (rs.code === '0x001806') {
          this.codeError = SERVER_STATUS_ACTIVE;
        }

        if (rs.code === '0x001817') {
          this.codeError = SERVER_STATUS_PENDING_HSM;
        }
      }

      if (rs.data) {
        this.codeError = null;
      }
    });
  }

  /**
   * Check one certificate for list certificate
   */
  clickCertificateSimCA(serialNumber: string, checked: boolean) {
    if (checked) {
      if (this.digitalCertificate.typeCertificate == this.certificateType.SIGN_SIM_CA) {
        this.dataSource.data.value.forEach(data => {
          data.checked = false;
        });

        this.dataSource.data.value.forEach(data => {
          if (data.serialNumber === serialNumber) {
            data.checked = true;
            this.enableButtonSave = true;
            // set tên chủ thể ngay lúc chọn CTS để block ảnh ký mặc định gen ảnh preview (PYC-84222)
            this.setIssuedTo(data.certificateName);
          }
        });
      } else if (this.digitalCertificate.typeCertificate == this.certificateType.CLOUD_CA) {
        this.cloudCaDataSource.data.value.forEach(data => {
          data.checked = false;
        });

        this.cloudCaDataSource.data.value.forEach(data => {
          if (data.serialNumber === serialNumber) {
            data.checked = true;
            this.enableButtonSave = true;
          }
        });
      } else {
        this.enableButtonSave = false;
      }
    } else {
      if (this.digitalCertificate.typeCertificate == this.certificateType.CLOUD_CA) {
        const lstChecked = this.cloudCaDataSource.data.value.filter(data => {
          return data.checked;
        });
        if (lstChecked.length <= 0) {
          this.enableButtonSave = false;
        }
      }

      if (this.digitalCertificate.typeCertificate == this.certificateType.SIGN_SIM_CA) {
        const lstChecked = this.dataSource.data.value.filter(data => {
          return data.checked;
        });
        if (lstChecked.length <= 0) {
          this.enableButtonSave = false;
          this.setIssuedTo('');
        }
      }
    }
  }
  clickCertificateCA(params : {serialNumber: string, activeDate: string, expireDate: string, checked: boolean}) {
    this.isShowNote = false;
    const {serialNumber, activeDate, expireDate, checked} = params;
    if (checked) {
      this.cloudCaDataSource.data.value.forEach(data => {
        data.checked = false;
      });

      this.cloudCaDataSource.data.value.forEach(data => {
        if (data.activeDate === activeDate &&  data.expireDate === expireDate && data.serialNumber === serialNumber) {
          data.checked = true;
          if (data.isExtend) {
            this.isShowNote = true;
          } else {
            this.isShowNote = false;
          }
          this.enableButtonSave = true;
          // set tên chủ thể ngay lúc chọn CTS để block ảnh ký mặc định gen ảnh preview (PYC-84222)
          this.setIssuedTo(data.certificateName);
        }
      });
    } else {
      const lstChecked = this.cloudCaDataSource.data.value.filter(data => {
        return data.checked;
      });
      if (lstChecked.length <= 0) {
        this.enableButtonSave = false;
        this.setIssuedTo('');
      }
    }
  }

  clickCertificateEasyCA(params : {serialNumber: string, activeDate: string, expireDate: string, checked: boolean}){
    const {serialNumber, activeDate, expireDate, checked} = params;
    if (checked) {
      this.easyCaDataSource.data.value.forEach(data => {
        data.checked = false;
      });

      this.easyCaDataSource.data.value.forEach(data => {
        if (data.activeDate === activeDate &&  data.expireDate === expireDate && data.serialNumber === serialNumber) {
          data.checked = true;
          this.enableButtonSave = true;
          this.setIssuedTo(data.issuedTo);
        }
      });
    } else {
      const lstChecked = this.easyCaDataSource.data.value.filter(data => {
        return data.checked;
      });
      if (lstChecked.length <= 0) {
        this.enableButtonSave = false;
        this.setIssuedTo('');
      }
    }
  }

  clickCertificateVNEID(params : {serialNumber: string, activeDate: string, expireDate: string, checked: boolean}) {
    this.isShowNote = false;
    const {serialNumber, activeDate, expireDate, checked} = params;
    if (checked) {
      this.VNeIDDataSource.data.value.forEach(data => {
        data.checked = false;
      });

      this.VNeIDDataSource.data.value.forEach(data => {
        if (data.activeDate === activeDate &&  data.expireDate === expireDate && data.serialNumber === serialNumber) {
          data.checked = true;
          if (data.isExtend) {
            this.isShowNote = true;
          } else {
            this.isShowNote = false;
          }
          this.enableButtonSave = true;
          this.setIssuedTo(data.issuedTo);
        }
      });
    } else {
      const lstChecked = this.VNeIDDataSource.data.value.filter(data => {
        return data.checked;
      });
      if (lstChecked.length <= 0) {
        this.enableButtonSave = false;
        this.setIssuedTo('');
      }
    }
  }

  outPhoneNumberInput() {
    this.digitalCertificate.phoneNumber = this.digitalCertificate.phoneNumber.replace(/\s/g, '');
  }

  confirmDelete(){
    this.avatarUrl = '';
    this.fileImageUpload = null;
    this.imagePath = null;
    this.fileUpload = ''

  }


  /**
   * Get list certificate of sim CA
   */
  getCertificateOfSimCA() {
    this.dataSource = null;
    this.isShowNote = false;
    this.digitalCertificateService.getListCertificateSimCA(
      this.digitalCertificate.enterpriseId,
      this.digitalCertificateService.formatPhoneNumber(this.digitalCertificate.phoneNumber)
    ).subscribe(rs => {
      const today = new Date();
      const listCert = rs.data.filter(r => new Date(r.expireDate.replace(/-/g, '/')) >= today);
      let stt = 1;
      listCert.forEach(parent => {
        parent.STT = stt++;
      });
      if (listCert.length > 0) {
        this.dataSource = new DigitalCertificateSimCADataSource();
        this.dataSource.setData(listCert);
      } else {
        this.toastr.error(this.message.getMessage('validation.no_valid_certificate_simCA'));
      }
    });
  }

  getCertificateCloudCa() {
    this.isShowNote = false;
    this.cloudCaDataSource = null;
    this.digitalCertificateService.getListCertCloudCa(
      this.digitalCertificate.enterpriseId,
      this.digitalCertificate.cloudCaUsername,
      this.digitalCertificate.providerName
    ).subscribe(rs => {
      if(rs && rs.data){
        const today = new Date();
        const listCert = rs.data.filter(r => new Date(r.expireDate.replace(/-/g, '/')) >= today);
        let stt = 1;

        listCert.forEach(async parent => {
          parent.STT = stt++;
          parent.statusLabel = parent.isExtend ? await this.commonService.getMessage('form.extend') + this.digitalCertificate.providerName : parent.isUsed ? await this.commonService.getMessage('form.registered') : await this.commonService.getMessage('tooltips.not_register');
        });

        if (listCert.length > 0) {
          this.cloudCaDataSource = new DigitalCertificateCloudCaDataSource();
          this.cloudCaDataSource.setData(listCert);
        } else {
          this.toastr.error(this.message.getMessage('validation.no_valid_certificate_cloudCA'));
        }
      } else {
        if(rs.message){
          this.toastr.error(rs.message);
        } else {
          this.toastr.error(this.message.getMessage('validation.no_valid_certificate_2'));
        }
      }
    });
  }

  getCertificateVNEID() {
    this.isShowNote = false;
    this.VNeIDDataSource = null;
    this.digitalCertificateService.getListCertVNEID(
      this.digitalCertificate.enterpriseId,
      this.digitalCertificate.VNeIDDataUser
    ).subscribe(rs => {
      if(rs && rs.data){
        const today = new Date();
        const listCert = rs.data.filter(r => new Date(r.expireDate.replace(/-/g, '/')) >= today);
        let stt = 1;

        listCert.forEach(async parent => {
          parent.STT = stt++;
          parent.statusLabel = parent.isExtend ? await this.commonService.getMessage('form.extend') + this.digitalCertificate.providerName : parent.isUsed ? await this.commonService.getMessage('form.registered') : await this.commonService.getMessage('tooltips.not_register');
        });

        if (listCert.length > 0) {
          this.VNeIDDataSource = new DigitalCertificateVNeIDDataSource();
          this.VNeIDDataSource.setData(listCert);
        } else {
          this.toastr.error(this.message.getMessage('validation.no_valid_certificate_cloudCA'));
        }
      } else {
        if(rs.message){
          this.toastr.error(rs.message);
        } else {
          this.toastr.error(this.message.getMessage('validation.no_valid_certificate_2'));
        }
      }
    });
  }

  getCertificateEasyCa(){
    this.isShowNote = false;
    this.easyCaDataSource = null;
    this.digitalCertificateService.getListCertEasyCa(
      this.digitalCertificate.enterpriseId,
      this.digitalCertificate.serial,
      this.digitalCertificate.pin
    ).subscribe(rs => {
      const today = new Date();
      const listCert = rs.data.filter(r => new Date(r.expireDate.replace(/-/g, '/')) >= today);
      let stt = 1;

      listCert.forEach(async parent => {
        parent.STT = stt++;
        parent.statusLabel = parent.isExtend ? await this.commonService.getMessage('form.extend') + this.digitalCertificate.providerName : parent.isUsed ? await this.commonService.getMessage('form.registered') : await this.commonService.getMessage('tooltips.not_register');
      });

      if (listCert.length > 0) {
        this.easyCaDataSource = new DigitalCertificateEasyCaDataSource();
        this.easyCaDataSource.setData(listCert);
      } else {
        this.toastr.error(this.message.getMessage('validation.no_valid_certificate_cloudCA'));
      }
    });
  }

  getQrMySign() {
    document.getElementById('toggleBar').click();
    const data = {isMySign: true};
    const dialogRef = this.dialog.open(DowloadAppMobileComponent, {
      width: this.deviceService.isMobile() ? '100%' : '60%',
      maxWidth: this.deviceService.isMobile() ? '90vw' : '40vw',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true,
      data : data
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  getQrVNeID() {
    document.getElementById('toggleBar').click();
    const dialogRef = this.dialog.open(DowloadAppVNeIDMobileComponent, {
      width: this.deviceService.isMobile() ? '100%' : '60%',
      maxWidth: this.deviceService.isMobile() ? '90vw' : '40vw',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  setSessionId(value) {
    this.sessionId = value;
  }

  /**
   * Download sign plugin
   */
  downloadSignPlugin(os ?: string) {
    let fileName = this.digitalCertificateService.getSignPluginName(os);
    this.digitalCertificateService.downloadSignPlugin(os).subscribe(rs => {
      this.downLoadFile(rs, 'application/octet-stream', fileName);
    });
  }

  getLinkDownload(os ?: string){
    return  this.digitalCertificateService.linkDownloadPluginSign(os);
  }


  handlePreview = async (file: NzUploadFile) => {
    this.previewVisible = true;
  }

  /**
   * Method is use to download file.
   * @param data - Array Buffer data
   * @param type - type of the document.
   * @param fileName - file name of file
   */
  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  deleteCertificate(username) {
    this.isFormChanging = true;
    this.userNameArr = this.userNameArr.filter(v => v.id !== username.id);
  }

  onChangeUserSignSearch(event): void {
    if (this.inputUserValue.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.digitalCertificateService.getUserNameAndFullName(this.inputUserValue.trim())
        .subscribe(result => {
          this.filteredUserOptions = result.data;
          this.nzCheckLoadingUser = false;
        }, error => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  autocompleteUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (this.userNameArr && this.userNameArr.length > 4) {
        this.toastr.error(this.message.getMessage('messages.error_signing_method_manager_5'));
        return false;
      }

      const duplicateItem = this.userNameArr.find(item => item.id === model.id);
      if (!duplicateItem || duplicateItem.length === 0) {
        this.userNameArr.push(model);
      }
    }
  }
  syncDataCert(cert) {
    this.avatarUrl = '';
    this.getCertificateById(cert.certificateId, cert.certificateDetailId)
  }

  disableGetCertifcate: boolean = false;
  onNumberInput() {
    if (!this.digitalCertificate.VNeIDDataUser) {
      return;
    }

    this.disableGetCertifcate = false;
  }

  blockNonNumber(event: KeyboardEvent) {
    if (event.ctrlKey || event.metaKey) {
      const ctrlAllowed = ['a', 'c', 'v', 'x', 'z'];
      if (ctrlAllowed.includes(event.key.toLowerCase())) {
        return;
      }
    }
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
    ];

    if (allowedKeys.includes(event.key)) {
      return;
    }
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  blockNonNumberPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData.getData('text') || '';
    if (!/^[0-9]+$/.test(pasted)) {
      event.preventDefault(); // chặn dán nếu có ký tự không phải số
    }
  }
}

export class DigitalCertificateSimCA {
  id: string;
  certificateName: string;
  serialNumber: string;
  taxCode: string;
  activeDate: string;
  expireDate: string;
  isUsed: boolean;
  checked: boolean;
  certificates: Array<string>;
}

export class DigitalCertificateSimCADataSource extends DataSource<DigitalCertificateSimCA> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<DigitalCertificateSimCA[]>([]);

  constructor() {
    super();
  }


  setData(data: DigitalCertificateSimCA[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<DigitalCertificateSimCA[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }

}



export class CloudCaProvider {
  name: string;
  id: number;
}

export class DigitalCertificateEasyCa {
  id: string;
  issuedTo: string;
  serialNumber: string;
  taxCode: string;
  activeDate: string;
  expireDate: string;
  distinguishedName: string;
  certRawdata: string;
  issuedBy: string;
  isUsed: boolean;
  checked: boolean;
  certificates?: Array<string>;
}

export class DigitalCertificateEasyCaDataSource extends DataSource<DigitalCertificateEasyCa> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<DigitalCertificateEasyCa[]>([]);

  constructor() {
    super();
  }


  setData(data: DigitalCertificateEasyCa[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<DigitalCertificateEasyCa[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }

}

export class DigitalCertificateVNeID {
  id: string;
  issuedTo: string;
  serialNumber: string;
  taxCode: string;
  activeDate: string;
  expireDate: string;
  distinguishedName: string;
  certRawdata: string;
  issuedBy: string;
  isUsed: boolean;
  checked: boolean;
  certificates?: Array<string>;
  isExtend: boolean;
}

export class DigitalCertificateVNeIDDataSource extends DataSource<DigitalCertificateVNeID> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<DigitalCertificateVNeID[]>([]);

  constructor() {
    super();
  }


  setData(data: DigitalCertificateVNeID[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<DigitalCertificateVNeID[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }

}
